<template>
  <a-icon :icon="icon" width="20px" height="20px" :style="{ color }" />
</template>

<script>
export default {
  name: 'AnswerCorrectnessIcon',
  props: {
    correct: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icon() {
      return this.correct ? 'mdi:check-circle-outline' : 'mdi:close-circle-outline'
    },

    color() {
      return this.correct ? '#10b981' : '#ef4444'
    }
  }
}
</script>
